interface LabelWithDetailProps {
  detail?: string | null;
  label: string;
}

export const LabelWithDetail = ({ label, detail }: LabelWithDetailProps) => (
  <>
    <span className="text-darkest font-bold">{label}</span>
    {detail && (
      <>
        {" "}
        <span className="text-darkest font-normal">({detail})</span>
      </>
    )}
  </>
);
